module.exports = __webpack_public_path__ + "img/benoit13.a18cb608.jpg";